export default "__VITE_ASSET__4b19716f__";